function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0001 47.3327C11.1134 47.3327 0.666748 36.886 0.666748 23.9994C0.666748 11.1127 11.1134 0.666016 24.0001 0.666016C36.8867 0.666016 47.3334 11.1127 47.3334 23.9994C47.3193 36.8801 36.8809 47.3185 24.0001 47.3327ZM23.9627 42.666H24.0001C34.3057 42.6557 42.6532 34.2957 42.6481 23.99C42.6429 13.6844 34.2871 5.33269 23.9814 5.33269C13.6757 5.33269 5.3199 13.6844 5.31475 23.99C5.3096 34.2957 13.6571 42.6557 23.9627 42.666ZM19.3334 35.666L10.0001 26.3327L13.2901 23.0427L19.3334 29.0627L34.7101 13.686L38.0001 16.9993L19.3334 35.666Z",
  fill: "#16B187"
});

function SvgCircleCheckOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckOutline);
export default __webpack_public_path__ + "static/media/circle_check_outline.6cac8410.svg";
export { ForwardRef as ReactComponent };